<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'New customer'|translate}}
            </span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="customerForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'First name'|translate}}</mat-label>
                    <input name="firstName" formControlName="firstName" matInput required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Last name'|translate}}</mat-label>
                    <input name="lastName" formControlName="lastName" matInput required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'E-mail'|translate}}</mat-label>
                    <input name="email" formControlName="email" matInput>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Phone'|translate}}</mat-label>
                    <input name="phone" formControlName="phone" matInput required>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button *ngIf="action === 'edit'"
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(['delete',customerForm])"
                aria-label="Delete"
                matTooltip="Delete">
            {{'DELETE'|translate}}
        </button>

        <button *ngIf="action !== 'edit'"
                mat-button
                class="save-button"
                color="primary"
                (click)="matDialogRef.close(customerForm)"
                [disabled]="customerForm.invalid"
                aria-label="SAVE">
            {{'ADD'|translate}}
        </button>

        <button *ngIf="action === 'edit'"
                mat-button
                class="save-button"
                (click)="matDialogRef.close(['save',customerForm])"
                [disabled]="customerForm.invalid"
                aria-label="SAVE">
            {{'SAVE'|translate}}
        </button>

    </div>
</div>
